const wrapper = "_275wxeqnx5";
const input = "_275ig1p6ll";
const selectsWrapper = "_275sac0s67";
const select = "_275sn50nkn";

/** Ensure select dropdown positions itself over the settings lightbox */
const selectDropdown = "_275s1ap7xtb";
const buttonsWrapper = "_275bnqokd1";
const errorMessage = "_275esag7jt";
const button = "_275bfpdllj";

export { button, buttonsWrapper, errorMessage, input, select, selectDropdown, selectsWrapper, wrapper };
import "./modal.create-team.style.linaria.module.css";
//# sourceMappingURL=modal.create-team.style.js.map
